<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- SMTP基本参数 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.smtp") }}
          </span>
          <div class="lie smtp_basic">
            <table>
              <tbody>
                <tr>
                  <!-- 客户端IP最大并发连接 -->

                  <td>{{ $t("tab.smtp1") }}:</td>
                  <td>
                    <el-input
                      v-model="smtpd_client_connection_count_limit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 单位时间单IP最大允许连接数 -->

                  <td>{{ $t("tab.smtp2") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_client_connection_rate_limit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 单位时间单IP邮件数限制 -->

                  <td>{{ $t("tab.smtp3") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_client_message_rate_limit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 单位时间单IP最大允许收件人数 -->

                  <td>{{ $t("tab.smtp4") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_client_recipient_rate_limit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- SMTP允许最大邮件大小 -->

                  <td>{{ $t("tab.smtp5") }}:</td>

                  <td>
                    <el-input
                      v-model="message_size_limit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="15"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 队列最长生命周期 -->

                  <td>{{ $t("tab.smtp6") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="maximal_queue_lifetime"
                      placeholder
                    ></el-input>
                    <!--
                                    <el-select v-model="queue_life_unit" placeholder="h" class="duilie">
                                        <el-option v-for="item in queue" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                    -->
                  </td>
                </tr>
                <tr>
                  <!-- SMTP错误指令次数限制 -->

                  <td>{{ $t("tab.smtp7") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_soft_error_limit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr v-if="this.smtpd_session_max_msg_cn_show == 1">
                  <!-- smtp单个会话最大字节数 SMTP_SESSION_MAX_BYTES -->

                  <td>{{ $t("tab.smtp8") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="smtpd_session_max_bytes"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="15"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.smtp8_title')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                <tr v-if="this.smtpd_session_max_msg_cn_show == 1">
                  <!-- smtp单个会话最大消息数 -->

                  <td>{{ $t("tab.smtp9") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_session_max_msg_cn"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr v-if="this.smtpd_negotiate_time_show == 1">
                  <!-- smtp问候延迟 -->

                  <td>{{ $t("tab.smtp10") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_negotiate_time"
                      placeholder
                      oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="2"
                    ></el-input>
                  </td>
                </tr>
                <tr v-if="this.smtpd_max_num_show == 1">
                  <!-- 最大SMTP连接数 -->

                  <td>{{ $t("tab.spams15") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_max_num"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <tr v-if="this.check_nb_rcpt_show == 1">
                  <!-- 单封邮件最大收件人数 -->

                  <td>{{ $t("tab.smtp11") }}:</td>

                  <td
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                    "
                  >
                    <el-checkbox
                      v-model="check_nb_rcpt"
                      style="padding-right: 10px"
                    ></el-checkbox>
                    <div style="padding-right: 10px">
                      {{ $t("tab.smtp12") }}:
                    </div>
                    <el-input
                      v-model="max_rcpt_from_local"
                      placeholder
                      style="width: 20%"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                    <div style="padding-right: 10px">
                      {{ $t("tab.smtp13") }}:
                    </div>
                    <el-input
                      v-model="max_rcpt_from_friend"
                      placeholder
                      style="width: 20%"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                    <div style="padding-right: 10px">
                      {{ $t("tab.smtp14") }}:
                    </div>
                    <el-input
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      v-model="max_rcpt_from_unknown"
                      placeholder
                      maxlength="6"
                      style="width: 20%"
                    ></el-input>
                  </td>
                </tr>
                <!-- smtp最大允许空闲 -->
                <tr v-if="this.smtpd_max_num_idle_show == 1">
                  <td>{{ $t("tab.spams16") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_max_num_idle"
                      placeholder
                      maxlength="6"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                <!-- ip段最大允许并发 -->
                <tr v-if="this.smtpd_max_num_ip_show == 1">
                  <td>{{ $t("tab.spams17") }}:</td>

                  <td>
                    <el-input
                      v-model="smtpd_max_num_ip"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <!-- MTA自带反向解析 -->
                <tr v-if="this.smtpd_peername_lookup_show == 1">
                  <td>{{ $t("tab.spams20") }}:</td>

                  <td
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                    "
                  >
                    <el-checkbox
                      v-model="smtpd_peername_lookup"
                      style="padding: 14px 0"
                    ></el-checkbox>
                  </td>
                </tr>
                <!-- 匿名邮件拦截 -->
                <tr v-if="this.anonymous_email_blocking_show == 1">
                  <td>{{ $t("tab.spams30") }}:</td>

                  <td
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                    "
                  >
                    <el-checkbox
                      v-model="anonymous_email_blocking"
                      style="padding: 14px 0"
                    ></el-checkbox>
                  </td>
                </tr>
                <!-- smtp的MTA基础频率周期 -->
                <tr>
                  <td>{{ $t("tab.spams18") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="anvil_rate_time_unit"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.spams19')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                <!-- defer队列投递间隔最低时间 -->
                <tr v-if="this.minimal_backoff_time_show == 1">
                  <td>{{ $t("tab.spams21") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="minimal_backoff_time"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <!-- defer队列投递间隔最大时间 -->
                <tr v-if="this.minimal_backoff_time_show == 1">
                  <td>{{ $t("tab.spams22") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="maximal_backoff_time"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <!-- defer队列投递扫描周期 -->
                <tr v-if="this.minimal_backoff_time_show == 1">
                  <td>{{ $t("tab.spams23") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="queue_run_delay"
                      placeholder
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      maxlength="6"
                    ></el-input>
                  </td>
                </tr>
                <!-- 退信周期，超过多少天，退信 -->
                <tr v-if="this.bounce_queue_lifetime_show == 1">
                  <td>{{ $t("tab.spams25") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="bounce_queue_lifetime"
                      placeholder
                    ></el-input>
                  </td>
                </tr>

                <!-- 退信账号名字 -->
                <tr v-if="this.bounce_queue_lifetime_show == 1">
                  <td>{{ $t("tab.spams27") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="bounce_notice_recipient"
                      placeholder
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save_smtp"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                    <!-- 
                                    <el-button type="danger" @click="cancel">{{ $t("tab.cancel") }}</el-button>-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>

        <!-- 安全基本参数 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.spams") }}
          </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 拦截动作 -->
                  <td>{{ $t("tab.spams1") }}:</td>
                  <td>
                    <el-select
                      v-model="filter_outer_action"
                      placeholder="请选择"
                      size="mini"
                      @change="filter_outer_action_change"
                    >
                      <el-option
                        v-for="item in filter_outer"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
                <tr v-if="this.show_action == true">
                  <!-- 增加标记的信头key -->
                  <td>{{ $t("tab.spams13") }}:</td>

                  <td>
                    <el-input v-model="header_key" placeholder></el-input>
                  </td>
                </tr>
                <tr v-if="this.show_action == true">
                  <!-- 增加标记的信头value -->
                  <td>{{ $t("tab.spams14") }}:</td>

                  <td>
                    <el-input v-model="header_value" placeholder></el-input>
                  </td>
                </tr>

                <tr>
                  <!-- 是否启动自动白名单 -->
                  <td>{{ $t("tab.spams2") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="check_awl" @change="change">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.spams2001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 拦截垃圾是否隔离 -->
                  <td>{{ $t("tab.spams3") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="save_reject_msg">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.spams3001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <!-- 是否保存本地账号外发隔离邮件 -->
                <tr>
                  <td>{{ this.save_reject_outmail_text }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="save_reject_outmail">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.save_reject_outmail_hint"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 是否启用内容白名单 -->
                  <td>{{ $t("tab.spams4") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="check_white_regex">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.spams4001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 是否启用弱密码检查 -->
                  <td>{{ $t("tab.spams5") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="weak_pwd_chk">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.spams5001')"
                      show-icon
                      :closable="false"
                      type="warning"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 是否启用SMTP认证IP控制 -->
                  <td>{{ $t("tab.spams6") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="smtp_auth_ip_limit">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.spams6001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 关闭统计本地指纹 -->
                  <td>{{ $t("tab.spams7") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="close_local_digest">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.spams7001')"
                      show-icon
                      :closable="false"
                      type="warning"
                    ></el-alert>
                  </td>
                </tr>
                <!-- 是否开启主题审计 -->
                <tr>
                  <td>{{ $t("tab.spams31") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="chk_sub_audit">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.chk_sub_audit_hint"
                      show-icon
                      :closable="false"
                      type="warning"
                    ></el-alert>
                  </td>
                </tr>
                <!-- 主题审计周期 -->
                <tr>
                  <td>{{ $t("tab.spams8") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="sub_audit_time"
                      placeholder
                      maxlength="6"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      style="margin-bottom: 0; width: 80px"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.spams8001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 主题审计次数 -->
                  <td>{{ $t("tab.spams9") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="sub_audit_num"
                      placeholder
                      maxlength="6"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      style="margin-bottom: 0; width: 80px"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.spams9001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <!-- 是否打开全局增加主题标记 -->
                <tr>
                  <td>{{ this.add_subject_spam_tag_on_text }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="add_subject_spam_tag_on">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.add_subject_spam_tag_on_hint"
                      show-icon
                      :closable="false"
                      type="warning"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 增加的主题内容 -->
                  <td>{{ this.add_gl_subject_tag_text }}:</td>
                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="add_gl_subject_tag"
                      placeholder
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 同一IP最大不同url数 -->
                  <td>{{ $t("tab.spams10") }}:</td>
                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="max_nb_url_on_one_ip"
                      placeholder
                      maxlength="6"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      style="margin-bottom: 0; width: 80px"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.spams10001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- url黑名单检查最大链接数 -->
                  <td>{{ $t("tab.spams11") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="chk_body_url_at_max_linknum"
                      placeholder
                      maxlength="6"
                      oninput="value=value.replace(/[^\d]|^0/g,'')"
                      style="margin-bottom: 0; width: 80px"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.spams11001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 通知邮件标题 -->
                  <td>{{ $t("tab.spams12") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-input
                      v-model="noticy_subject"
                      placeholder
                      style="margin-bottom: 0"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.spams12001')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr v-if="this.pass_on_yes_show == 1">
                  <!-- 猜测密码 -->
                  <td>{{ this.pass_on_yes_text }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="pass_on_yes">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.pass_on_yes_hint"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr v-if="this.filter_level_show == 1">
                  <!-- 过滤等级 -->
                  <td>{{ $t("tab.spams28") }}:</td>
                  <td>
                    <el-select
                      v-model="filter_level"
                      placeholder="请选择"
                      size="mini"
                      @change="filter_outer_action_change"
                    >
                      <el-option
                        v-for="item in filter_level_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save1"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                    <!-- 
                                    <el-button type="danger" icon="el-icon-document-delete" @click="cancel">{{ $t("tab.cancel") }}</el-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <!-- 反病毒基本参数 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.virus") }}
          </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 是否启动病毒扫描 -->

                  <td>{{ $t("tab.virus6") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="check_virus">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.virus10')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 启用Clamav引擎 -->

                  <td>{{ $t("tab.virus9") }}:</td>

                  <td>
                    <el-checkbox-group v-model="clamav">
                      <el-checkbox label disabled></el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>

                <tr>
                  <!-- 拦截病毒是否隔离 -->

                  <td>{{ $t("tab.virus8") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="save_virus_msg">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.virus12')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 病毒扫描动作 -->

                  <td>{{ $t("tab.virus1") }}:</td>
                  <td>
                    <el-select
                      v-model="scanner_action"
                      placeholder="请选择"
                      style="width: 280px"
                    >
                      <el-option
                        v-for="item in q_action"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
                <tr>
                  <!-- 病毒扫描超时时间 -->

                  <td>{{ $t("tab.virus2") }}:</td>

                  <td>
                    <el-input v-model="scanner_timeout" placeholder></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 病毒扫描最大邮件大小 -->

                  <td>{{ $t("tab.virus3") }}:</td>

                  <td style="display: flex; flex-direction: row" class="bingdu">
                    <el-input
                      v-model="scanner_maxsize"
                      placeholder
                      style="width: 200px"
                    ></el-input>
                    <el-select
                      v-model="scanner_size_unit"
                      placeholder="请选择"
                      size="mini"
                    >
                      <el-option
                        v-for="item in size_unit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
                <!-- 是否启用360杀毒 360_ANTI_VIRUS_ON NO -->

                <tr v-if="this.anit_virus_on_show == 1">
                  <td>{{ $t("tab.virus13") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="anit_virus_on">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.virus14')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr v-if="this.anit_virus_on_show1 == 1">
                  <!-- 360360杀毒二进制程序-->

                  <td>{{ $t("tab.virus15") }}:</td>

                  <td>
                    <el-input v-model="anit_virus_prog" placeholder></el-input>
                  </td>
                </tr>
                <tr v-if="this.anit_virus_on_show2 == 1">
                  <!-- 360杀毒中间件 -->

                  <td>{{ $t("tab.virus16") }}:</td>

                  <td>
                    <el-input
                      v-model="anit_virus_socket"
                      placeholder
                    ></el-input>
                  </td>
                </tr>
                <tr v-if="this.ruixing_virus_show == 1">
                  <!-- 启用景云反病毒引擎 -->

                  <td>{{ $t("tab.virus7") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="qm_scan">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.virus11')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr v-if="this.ruixing_virus_show == 1">
                  <!-- 景云反病毒引擎端口 -->

                  <td>{{ $t("tab.virus4") }}:</td>

                  <td>
                    <el-input v-model="qm_scan_port" placeholder></el-input>
                  </td>
                </tr>
                <tr v-if="this.ruixing_virus_show == 1">
                  <!-- 景云反病毒引擎主机 -->

                  <td>{{ $t("tab.virus5") }}:</td>

                  <td>
                    <el-input v-model="qm_scan_host" placeholder></el-input>
                  </td>
                </tr>
                <!-- 是否清理病毒 -->
                <tr v-if="this.clean_virus_on_show == 1">
                  <td>{{ $t("tab.virus17") }}:</td>
                  <td>
                    <el-checkbox-group v-model="clean_virus_on">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>
                <!-- 是否在保存spam的时候，清理病毒 -->
                <tr v-if="this.clean_virus_on_show == 1">
                  <td>{{ $t("tab.virus18") }}:</td>
                  <td>
                    <el-checkbox-group v-model="clean_virus_while_savespam_on">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>
                <!-- 是否重定向病毒文件 -->
                <tr v-if="this.redirect_virus_attach_on_show == 1">
                  <td>{{ $t("tab.virus19") }}:</td>
                  <td>
                    <el-checkbox-group v-model="redirect_virus_attach_on">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save2"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                    <!--
                                    <el-button type="danger" icon="el-icon-document-delete" @click="cancel">{{ $t("tab.cancel") }}</el-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <!-- 日志清理设置 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.lagc") }}
          </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 邮件日志文件保留天数 -->

                  <td>{{ $t("tab.logc1") }}:</td>

                  <td>
                    <el-input
                      v-model="maillog_file_save_days"
                      placeholder
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 过滤日志文件保留天数 -->

                  <td>{{ $t("tab.logc2") }}:</td>

                  <td>
                    <el-input
                      v-model="milterlog_file_save_days"
                      placeholder
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 认证日志文件保留天数 -->

                  <td>{{ $t("tab.logc3") }}:</td>

                  <td>
                    <el-input
                      v-model="fauth_file_save_days"
                      placeholder
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 队列日志保留天数 -->

                  <td>{{ $t("tab.logc4") }}:</td>

                  <td>
                    <el-input v-model="queue_save_days" placeholder  oninput="value=value.replace(/[^\d]|^0/g,'')"></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 实时过滤日志保留天数 -->

                  <td>{{ $t("tab.logc5") }}:</td>

                  <td>
                    <el-input
                      v-model="conn_spam_save_days"
                      placeholder
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 隔离邮件保留天数 -->

                  <td>{{ $t("tab.logc6") }}:</td>

                  <td
                    style="display：flex;flex-direction: row;
"
                  >
                    <el-input v-model="spam_save_days" placeholder  oninput="value=value.replace(/[^\d]|^0/g,'')"></el-input>
                    <el-button
                    v-show="this.logcleam_person_show==1"
                      style="margin-bottom: 8px; margin-top: 8px"
                      type="primary"
                      @click="different_categories_edit"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tabs.categories") }}</el-button
                    >
                  </td>
                </tr>
                <tr>
                  <!-- 归档邮件保留天数 -->

                  <td>{{ $t("tab.logc7") }}:</td>

                  <td>
                    <el-input
                      v-model="archive_save_days"
                      placeholder
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                  <tr v-show="this.area_save_days_show==1">
                  <!--  区域邮件保留天数 -->

                  <td>{{ this.area_save_days_text }}:</td>

                  <td>
                    <el-input
                      v-model="area_save_days"
                      placeholder
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                    ></el-input>
                  </td>
                </tr>
                <tr >
                  <!-- 每页日志默认显示条数 -->

                  <td>{{ $t("tab.logc8") }}:</td>

                  <td>
                    <el-select
                      v-model="log_dft_pagesize"
                      placeholder="请选择"
                      
                     
                    >
                      <el-option
                        v-for="item in log_dft_pagesize_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                     </el-select>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save3"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                    <!--
                                    <el-button type="danger" icon="el-icon-document-delete" @click="cancel">{{ $t("tab.cancel") }}</el-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="pop-up pop-up1"
            v-show="tanchu"
            v-drag="{ handle: '.pop_up_text_add' }"
          >
            <div class="pop_up_text pop_up_text_add">
            <span class="span_pad"></span>  {{ $t("tabs.categories") }}
            </div>
            <div class="find">
              <div
                class="find1"
                v-for="v in different_ategories_arr"
                :key="v.id"
              >
                <div class="find-text" style="padding-right: 12px">
                  <!-- 密码最小长度 -->
                  {{ v.label }} :
                </div>
                <div class="block block1">
                  <el-input v-model="v.value" placeholder=""></el-input>
                </div>
              </div>
            </div>

            <el-row>
              <el-button type="primary" @click="save_weakpass()">{{
                $t("logs.save_a")
              }}</el-button>
              <el-button type="danger" @click="off_weakpass()">{{
                $t("logs.save_b")
              }}</el-button>
            </el-row>
          </div>
          <div class="gray" v-show="tanchu"></div>
        </el-tab-pane>
        <!-- 警报设置 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.alert") }}
          </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 警报通知发件人 -->

                  <td>{{ $t("tab.alert1") }}:</td>

                  <td>
                    <el-input
                      v-model="alert_sender"
                      placeholder
                      style="margin-bottom: 0"
                    ></el-input>
                    <el-alert
                      :title="this.alert_sender_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 警报通知收件人 -->

                  <td>{{ $t("tab.alert2") }}:</td>

                  <td>
                    <el-input
                      v-model="alert_recipient"
                      placeholder
                      style="margin-bottom: 0"
                    ></el-input>
                    <el-alert
                      :title="this.alert_recipient_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>

                <tr>
                  <!-- 异常程序 -->

                  <td>{{ $t("tab.alert3") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_prosess">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.alert_type_prosess_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 异常账户 -->

                  <td>{{ $t("tab.alert4") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_sender">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.alert_type_sender_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 版本升级 -->

                  <td>{{ $t("tab.alert5") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_update">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.alert_type_update_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 授权到期 -->

                  <td>{{ $t("tab.alert6") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_license">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="this.alert_type_license_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 硬盘容量 -->

                  <td>{{ $t("tab.alert7") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_disk">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-input
                      v-model="alert_disk_quota"
                      placeholder
                      style="width: 80px"
                    ></el-input>
                    <el-alert
                      :title="this.alert_type_disk_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 异常IP认证 -->

                  <td>{{ $t("tab.alert8") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_auth_ip">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-input
                      v-model="alert_ip_auth_quota"
                      placeholder
                      style="width: 80px"
                    ></el-input>
                    <el-alert
                      :title="this.alert_type_auth_ip_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 异常IP拒绝 -->

                  <td>{{ $t("tab.alert9") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_rej_ip">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-input
                      v-model="alert_ip_rej_quota"
                      placeholder
                      style="width: 80px"
                    ></el-input>
                    <el-alert
                      :title="this.alert_type_rej_ip_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 队列报警 -->

                  <td>{{ $t("tab.alert10") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_type_cur_queue">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-input
                      v-model="alert_cur_queue_quota"
                      placeholder
                      style="width: 80px"
                    ></el-input>
                    <el-alert
                      title="设置系统当前队列数告警值，是否发送告警邮件（每小时检查并发送一次）"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <!-- 到期时间 -->
                <tr>
                  <td>{{ $t("tab.alert15") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="alert_cert_expire">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>

                    <el-alert
                      :title="this.alert_cert_expire_show"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save4"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                    <!--
                                    <el-button type="danger" icon="el-icon-document-delete" @click="cancel">{{ $t("tab.cancel") }}</el-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <!-- 实时黑名单 -->
        <el-tab-pane label>
          <span slot="label">
            {{ $t("tab.real") }}
          </span>
          <div class="main">
            <el-button
              @click="add_black_five()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("tab.alert13") }}</el-button
            >
            <el-alert
              :title="$t('tab.alert14')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>

          <div class="switch1">
            <div class="table" v-loading="loading">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5"
              >
                <el-table-column
                  prop="REAL_ADDR"
                  label="域名地址"
                ></el-table-column>
                <el-table-column
                  prop="REAL_CODE"
                  label="返回代码IP"
                ></el-table-column>

                <el-table-column prop="address" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="handleClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="save51(scope.$index, scope.row)"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_local_domain' }"
            >
              <div class="pop_up_text pop_up_text_local_domain">
                <span class="span_pad"></span> {{ $t("tab.alert13") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("tab.alert11") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="real_addr" placeholder></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("tab.alert12") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="real_code" placeholder></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save5()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div
              class="pop-up"
              v-show="tanchu1"
              v-loading="loading_five"
              v-drag="{ handle: '.pop_up_text_relay_domain' }"
            >
              <div class="pop_up_text pop_up_text_relay_domain">
                <span class="span_pad"></span> {{ $t("tab.alert16") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("tab.alert11") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #666">
                      {{ this.real_addr }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("tab.alert12") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="real_code" placeholder></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save52()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend1()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu1"></div>
          </div>
        </el-tab-pane>
        <!-- 远程syslog配置 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.remote") }}
          </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 启用实时过滤日志syslog -->

                  <td>{{ $t("tab.remote_a1") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="filterlog_syslog">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.remote_a2')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 远程syslog主机 -->

                  <td>{{ $t("tab.remote_a3") }}:</td>

                  <td>
                    <el-input
                      v-model="syslog_remote_host"
                      placeholder
                      style="margin-bottom: 0"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.remote_a4')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 添加syslog信头key -->

                  <td>{{ $t("tab.remote_a5") }}:</td>

                  <td style="width: 33%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 6 }"
                      placeholder=""
                      v-model="add_syslog_name"
                    >
                    </el-input>
                    <el-alert
                      :title="$t('tab.remote_a6')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                  <el-alert
                    :title="$t('tab.remote_a7')"
                    type="warning"
                    show-icon
                    :closable="false"
                    style="
                      width: 386px;
                      height: 70px;
                      line-height: 0;
                      text-align: left;
                    "
                  ></el-alert>
                </tr>
                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save6"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <!-- 离线测试配置 -->
        <el-tab-pane>
          <span slot="label">
            {{ $t("tab.remote1") }}
          </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 启用离线测试 -->

                  <td>{{ $t("tab.remote_b1") }}:</td>

                  <td style="display: flex; flex-direction: row">
                    <el-checkbox-group v-model="offline_test_on">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('tab.remote_b2')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 测试发送账号 -->

                  <td>{{ $t("tab.remote_b3") }}:</td>

                  <td>
                    <el-input
                      v-model="offline_test_sender"
                      placeholder
                      style="margin-bottom: 0"
                    ></el-input>
                    <el-alert
                      :title="$t('tab.remote_b4')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td style="display: flex; flex-direction: row">
                    <el-button
                      type="primary"
                      @click="save7"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      logcleam_person_show:0,
      area_save_days_show:0,
      area_save_days:'',
      area_save_days_text:'',
      add_subject_spam_tag_on_text: "",
      add_subject_spam_tag_on_hint: "",
      add_subject_spam_tag_on: true,
      add_gl_subject_tag_text: "",
      add_gl_subject_tag_hint: "",
      add_gl_subject_tag: "",
      save_reject_outmail_text: "",
      save_reject_outmail_hint: "",
      save_reject_outmail: true,
      different_ategories_arr: [],
      different_categories1: "",
      minimal_backoff_time: "",
      minimal_backoff_time_show: "",
      maximal_backoff_time: "",
      queue_run_delay: "",
      bounce_queue_lifetime: "",
      bounce_queue_lifetime_show: "",
      bounce_notice_recipient: "",
      clean_virus_while_savespam_on: true,
      clean_virus_on: true,
      clean_virus_on_show: "",
      redirect_virus_attach_on: false,
      redirect_virus_attach_on_show: "",
      anvil_rate_time_unit: "",
      smtpd_peername_lookup_show: "",
      smtpd_max_num_idle: "",
      smtpd_max_num_idle_show: "",
      smtpd_max_num_ip: "",
      smtpd_max_num_ip_show: "",
      smtpd_peername_lookup: true,
      anonymous_email_blocking: true,
      anonymous_email_blocking_show: "",
      check_nb_rcpt: false,
      smtpd_max_num_show: "",
      check_nb_rcpt_show: "",
      max_rcpt_from_unknown: "",
      max_rcpt_from_local: "",
      max_rcpt_from_friend: "",
      filter_level: "middle",
      filter_level_show: "",
      filter_level_arr: [],
      pass_on_yes_text: "",
      pass_on_yes_hint: "",
      pass_on_yes: true,
      pass_on_yes_show: "",
      alert_cert_expire_show: "",
      alert_cert_expire: false,
      ruixing_virus_show: "",
      anit_virus_ruisxing_show: "",
      anit_virus_on_show: "",
      anit_virus_on_show1: "",
      anit_virus_on_show2: "",
      anit_virus_socket: "",
      anit_virus_prog: "",
      anit_virus_on: false,
      smtpd_negotiate_time_show: "",
      smtpd_session_max_msg_cn_show: "",
      smtpd_negotiate_time: "",
      smtpd_session_max_msg_cn: "",
      smtpd_session_max_bytes: "",
      // 客户端IP最大并发连接
      smtpd_client_connection_count_limit: "",
      //单位时间单IP最大允许连接数
      smtpd_client_connection_rate_limit: "",
      //单位时间单IP邮件数限制
      smtpd_client_message_rate_limit: "",
      //单位时间单IP最大允许收件人数
      smtpd_client_recipient_rate_limit: "",
      //SMTP允许最大邮件大小
      message_size_limit: "",
      //队列最长生命周期
      maximal_queue_lifetime: "",
      //SMTP错误指令次数限制
      smtpd_soft_error_limit: "",
      smtpd_max_num: "",
      // 反垃圾基本参数,
      check_awl: [],
      save_reject_msg: [],
      check_white_regex: [],
      weak_pwd_chk: false,
      smtp_auth_ip_limit: [],
      close_local_digest: [],
      chk_sub_audit: true,
      chk_sub_audit_hint: "",
      sub_audit_time: "",
      sub_audit_num: "",
      max_nb_url_on_one_ip: "",
      chk_body_url_at_max_linknum: "",
      noticy_subject: "",
      header_value: "",
      header_key: "",
      //   拦截动作
      filter_outer_action: [],
      filter_outer: [],
      //   反病毒
      scanner_action: [],
      scanner_timeout: "",
      scanner_maxsize: "",
      qm_scan_port: "",
      qm_scan_host: "",
      check_virus: [],
      qm_scan: [],
      save_virus_msg: [],
      scanner_size_unit: [],
      q_action: [],
      clamav: true,
      //   日志清理设置
      maillog_file_save_days: "",
      milterlog_file_save_days: "",
      fauth_file_save_days: "",
      queue_save_days: "",
      conn_spam_save_days: "",
      spam_save_days: "",
      archive_save_days: "",
      log_dft_pagesize: "",
      // 报警设置
      alert_sender: "",
      alert_sender_show: "",
      alert_recipient: "",
      alert_recipient_show: "",
      alert_type_disk: [],
      alert_type_disk_show: "",
      alert_disk_quota: "",
      alert_type_prosess: [],
      alert_type_prosess_show: "",
      alert_type_auth_ip: [],
      alert_type_auth_ip_show: "",
      alert_ip_auth_quota: "",
      alert_type_rej_ip: [],
      alert_type_rej_ip_show: "",

      alert_ip_rej_quota: "",
      alert_type_sender: [],
      alert_type_sender_show: "",
      alert_type_update: [],
      alert_type_update_show: "",
      alert_type_cur_queue: [],
      alert_type_cur_queue_show: "",
      alert_cur_queue_quota: "",
      alert_type_license: [],
      alert_type_license_show: "",
      //实时黑名单
      loading_five:false,
      real_code: "",
      real_addr: "",
      // 远程配置
      add_syslog_name: "",
      syslog_remote_host: "",
      filterlog_syslog: [],
      // 离线测试
      offline_test_on: [],
      offline_test_sender: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",
      loading: true,
      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      tanchu1: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      // 时分
      queue_life_unit: "",
      size_unit: [
        {
          value: "KB",
          label: "KB",
        },
        {
          value: "MB",
          label: "MB",
        },
      ],
      queue: [
        {
          value: "0",
          label: "h",
        },
        {
          value: "1",
          label: "m",
        },
      ],
      checked: "",
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      radio: [],
      bxian: true,
      bxian1: false,
      data_loadok: "",
      show_action: false,
      log_dft_pagesize_arr:[],
    };
  },
  created() {
    //如果没有这句代码，select中初始化会是空白的，默认选中就无法实现
    // this.scanner_size_unit = this.size_unit[0].value;
  },
  mounted() {
    // this.scanner_size_unit = this.size_unit[0].value;
    this.getFileList();
    this.getFileList1();
    this.getFileList2();
    this.getFileList3();
    this.getFileList4();
    this.getFileList5();
    this.getFileList6();
    this.getFileList7();
  },
  methods: {
    off_weakpass: function () {
      this.tanchu = false;
    },
    different_categories_edit() {
      this.tanchu = true;
    },
    filter_outer_action_change(a) {
      // console.log(a)
      if (a == "X-HEADER") {
        this.show_action = true;
      } else {
        this.show_action = false;
      }
    },
    // 单选框选中
    change(a) {
      //   this.value = this.value == 0 ? 1 : 0;
      // console.log(this.value)
      this.check_awl = a;
      console.log(this.check_awl);
    },
    // 显示
    tan: function () {
      this.tanchu = true;
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
    },
    tanSend1: function () {
      this.tanchu1 = false;
    },
    tanOff: function () {
      this.tanchu = false;
    },
    // 数据

    // SMTP加载
    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_smtp_param",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.data_loadok = res.data.ret.ok;
            this.smtpd_client_connection_count_limit =
              res.data.ret.result.smtpd_client_connection_count_limit;
            this.smtpd_client_connection_rate_limit =
              res.data.ret.result.smtpd_client_connection_rate_limit;
            this.smtpd_client_message_rate_limit =
              res.data.ret.result.smtpd_client_message_rate_limit;
            this.smtpd_client_recipient_rate_limit =
              res.data.ret.result.smtpd_client_recipient_rate_limit;
            this.message_size_limit = res.data.ret.result.message_size_limit;
            this.maximal_queue_lifetime =
              res.data.ret.result.maximal_queue_lifetime;
            this.smtpd_soft_error_limit =
              res.data.ret.result.smtpd_soft_error_limit;
            this.smtpd_negotiate_time = res.data.ret.result.smtp_negotiate_time;
            this.smtpd_session_max_msg_cn =
              res.data.ret.result.smtp_session_max_msg_cn;
            this.smtpd_session_max_bytes =
              res.data.ret.result.smtp_session_max_bytes;
            this.smtpd_session_max_msg_cn_show =
              res.data.ret.result.SYS_SMTP_ONE_SESSION_MAX;
            this.smtpd_negotiate_time_show =
              res.data.ret.result.SYS_SMTP_HELO_DEFER_ON;
            this.smtpd_max_num = res.data.ret.result.sys_max_smtp_connection;
            this.smtpd_max_num_show =
              res.data.ret.result.SYS_MAX_SMTP_CONNECTION;
            this.check_nb_rcpt_show = res.data.ret.result.SYS_CHECK_NB_RCPT_ON;
            this.smtpd_peername_lookup_show =
              res.data.ret.result.SYS_SMTPD_PEERNAME_LOOKUP;
            // 三个defer
            this.minimal_backoff_time_show =
              res.data.ret.result.SYS_SMTP_DEFER_ON;
            // 空闲
            this.smtpd_max_num_idle_show =
              res.data.ret.result.SYS_SMTP_MAX_IDLE_ON;
            //ip并发
            this.smtpd_max_num_ip_show =
              res.data.ret.result.SYS_SMTP_IP24_MAX_LIMIT_ON;
            // 退信
            this.bounce_queue_lifetime_show =
              res.data.ret.result.SYS_SMTP_BOUNCE_QUEUE_LIFETIME;
            // 匿名邮件
            this.anonymous_email_blocking_show =
              res.data.ret.result.SYS_BANONYMOUS_EMAIL_BLOCKING;

            this.anvil_rate_time_unit =
              res.data.ret.result.anvil_rate_time_unit;
            this.minimal_backoff_time =
              res.data.ret.result.minimal_backoff_time;

            this.maximal_backoff_time =
              res.data.ret.result.maximal_backoff_time;
            this.queue_run_delay = res.data.ret.result.queue_run_delay;
            this.bounce_queue_lifetime =
              res.data.ret.result.bounce_queue_lifetime;
            this.bounce_notice_recipient =
              res.data.ret.result.bounce_notice_recipient;

            this.smtpd_peername_lookup =
              res.data.ret.result.smtpd_peername_lookup == 1 ? true : false;
            this.anonymous_email_blocking =
              res.data.ret.result.anonymous_email_blocking == 1 ? true : false;
            (this.check_nb_rcpt =
              res.data.ret.result.check_nb_rcpt == 1 ? true : false),
              (this.max_rcpt_from_unknown =
                res.data.ret.result.max_rcpt_from_unknown),
              (this.max_rcpt_from_local =
                res.data.ret.result.max_rcpt_from_local),
              (this.max_rcpt_from_friend =
                res.data.ret.result.max_rcpt_from_friend);
          }
        });
    },
    // SMTP保存
    save_smtp() {
     this.$save_hint_test();
     this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
     
      //单位时间单IP最大允许连接数
      let smtpd_client_connection_rate_limit = this
        .smtpd_client_connection_rate_limit;
      //单位时间单IP邮件数限制

      const smtpd_client_message_rate_limit = this
        .smtpd_client_message_rate_limit;
      //单位时间单IP最大允许收件人数
      const smtpd_client_recipient_rate_limit = this
        .smtpd_client_recipient_rate_limit;
      //SMTP允许最大邮件大小
      const message_size_limit = this.message_size_limit;
      //队列最长生命周期
      const maximal_queue_lifetime = this.maximal_queue_lifetime;
      //SMTP错误指令次数限制
      const smtpd_soft_error_limit = this.smtpd_soft_error_limit;

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_smtp_param",
        sid: sid,
        smtpd_client_connection_count_limit: this
          .smtpd_client_connection_count_limit,
        //2
        smtpd_client_connection_rate_limit: smtpd_client_connection_rate_limit,
        //3
        smtpd_client_message_rate_limit: smtpd_client_message_rate_limit,
        //4
        smtpd_client_recipient_rate_limit: smtpd_client_recipient_rate_limit,
        //5
        message_size_limit: message_size_limit,
        //6
        maximal_queue_lifetime: maximal_queue_lifetime,
        //7
        smtpd_soft_error_limit: smtpd_soft_error_limit,
        smtp_negotiate_time: this.smtpd_negotiate_time,
        smtp_session_max_msg_cn: this.smtpd_session_max_msg_cn,
        smtp_session_max_bytes: this.smtpd_session_max_bytes,
        data_loadok: this.data_loadok,
        sys_max_smtp_connection: this.smtpd_max_num,
        check_nb_rcpt: this.check_nb_rcpt == true ? 1 : 0,
        max_rcpt_from_unknown: this.max_rcpt_from_unknown,
        max_rcpt_from_local: this.max_rcpt_from_local,
        max_rcpt_from_friend: this.max_rcpt_from_friend,
        anvil_rate_time_unit: this.anvil_rate_time_unit,
        smtpd_peername_lookup: this.smtpd_peername_lookup == true ? 1 : 0,
        anonymous_email_blocking: this.anonymous_email_blocking == true ? 1 : 0,

        minimal_backoff_time: this.minimal_backoff_time,
        bounce_notice_recipient: this.bounce_notice_recipient,
        maximal_backoff_time: this.maximal_backoff_time,
        queue_run_delay: this.queue_run_delay,
        bounce_queue_lifetime: this.bounce_queue_lifetime,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList();

            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 安全基本参数加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_filter_param",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.save_reject_outmail =
              res.data.ret.result.SAVE_REJECT_OUTMAIL == 0 ? false : true;
            this.save_reject_outmail_text =
              res.data.ret.result.save_reject_outmail_text;
            this.save_reject_outmail_hint =
              res.data.ret.result.save_reject_outmail_hint;
            this.add_subject_spam_tag_on =
              res.data.ret.result.ADD_SUBJECT_SPAM_TAG_ON == 0 ? false : true;
            this.add_subject_spam_tag_on_text =
              res.data.ret.result.add_subject_spam_tag_on_text;
            this.add_subject_spam_tag_on_hint =
              res.data.ret.result.add_subject_spam_tag_on_hint;

            this.add_gl_subject_tag = res.data.ret.result.ADD_GL_SUBJECT_TAG;
            this.add_gl_subject_tag_text =
              res.data.ret.result.add_gl_subject_tag_text;
            this.add_gl_subject_tag_hint =
              res.data.ret.result.add_gl_subject_tag_hint;

            this.check_awl =
              res.data.ret.result.CHECK_AWL == 0
                ? (this.check_awl = false)
                : (this.check_awl = true);
            // console.log(this.check_awl, 222222222);
            this.save_reject_msg =
              res.data.ret.result.SAVE_REJECT_MSG == 1
                ? (this.save_reject_msg = true)
                : (this.save_reject_msg = false);
            this.check_white_regex =
              res.data.ret.result.CHECK_WHITE_REGEX == 1
                ? (this.check_white_regex = true)
                : (this.check_white_regex = false);
            this.weak_pwd_chk =
              res.data.ret.result.WEAK_PWD_CHK == 1
                ? (this.weak_pwd_chk = true)
                : (this.weak_pwd_chk = false);
            this.smtp_auth_ip_limit =
              res.data.ret.result.CHK_SMTP_AUTH_IP_LIMIT == 0
                ? (this.smtp_auth_ip_limit = false)
                : (this.smtp_auth_ip_limit = true);
            this.close_local_digest =
              res.data.ret.result.CLOSE_LOCAL_DIGEST == 1
                ? (this.close_local_digest = true)
                : (this.close_local_digest = false);

            this.chk_sub_audit =
              res.data.ret.result.CHK_SUB_AUDIT == 1
                ? (this.chk_sub_audit = true)
                : (this.chk_sub_audit = false);

            this.chk_sub_audit_hint = res.data.ret.result.chk_sub_audit_hint;
            this.sub_audit_time = res.data.ret.result.SUB_AUDIT_INTERVAL;
            this.sub_audit_num = res.data.ret.result.SUB_MAX_AUDIT_CN;
            this.max_nb_url_on_one_ip =
              res.data.ret.result.MAX_NB_URL_ON_ONE_IP;
            this.chk_body_url_at_max_linknum =
              res.data.ret.result.CHK_BODY_URL_AT_MAX_LINKNUM;
            this.noticy_subject = res.data.ret.result.FM_SUBJECT;
            this.header_value =
              res.data.ret.result.FILTER_OUTER_SPAM_ADD_HEADER_VALUE;
            this.header_key =
              res.data.ret.result.FILTER_OUTER_SPAM_ADD_HEADER_KEY;
            this.filter_outer = res.data.ret.q_action;
            this.filter_outer_action = res.data.ret.result.FILTER_OUTER_ACTION;
            if (this.filter_outer_action == "X-HEADER") {
              this.show_action = true;
            } else {
              this.show_action = false;
            }
            this.pass_on_yes =
              res.data.ret.result.GUESS_PASS_ON == 1 ? true : false;
            this.pass_on_yes_show =
              res.data.ret.result.SYS_ZIPFILE_GUESS_PASS_ON;
            this.pass_on_yes_text = res.data.ret.result.GUESS_PASS_ON_TEXT;
            this.pass_on_yes_hint = res.data.ret.result.GUESS_PASS_ON_HINT;
            this.data_loadok = res.data.ret.ok;
            this.filter_level_show =
              res.data.ret.result.SYS_FILTER_SET_POLICY_LEVEL;
            this.filter_level = res.data.ret.result.filter_level;
            this.filter_level_arr = res.data.ret.q_filter_level;
            // this.filter_level_show=res.data.ret.SYS_FILTER_SET_POLICY_LEVEL
          }
        });
    },
    // 反垃圾保存
    save1() {
      this.$disable_hint_test();
      this.$save_hint_test();
      // this.loading = true;
      console.log(this.weak_pwd_chk);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let CHECK_AWL =
        this.check_awl == false ? (CHECK_AWL = 0) : (CHECK_AWL = 1);

      let SAVE_REJECT_MSG =
        this.save_reject_msg == true
          ? (SAVE_REJECT_MSG = 1)
          : (SAVE_REJECT_MSG = 0);
      let CHECK_WHITE_REGEX =
        this.check_white_regex == true
          ? (CHECK_WHITE_REGEX = 1)
          : (CHECK_WHITE_REGEX = 0);

      let CHK_SMTP_AUTH_IP_LIMIT =
        this.smtp_auth_ip_limit == false
          ? (CHK_SMTP_AUTH_IP_LIMIT = 0)
          : (CHK_SMTP_AUTH_IP_LIMIT = 1);
      let CLOSE_LOCAL_DIGEST =
        this.close_local_digest == true
          ? (CLOSE_LOCAL_DIGEST = 1)
          : (CLOSE_LOCAL_DIGEST = 0);
      let SUB_AUDIT_INTERVAL = this.sub_audit_time;
      let SUB_MAX_AUDIT_CN = this.sub_audit_num;

      let MAX_NB_URL_ON_ONE_IP = this.max_nb_url_on_one_ip;

      let CHK_BODY_URL_AT_MAX_LINKNUM = this.chk_body_url_at_max_linknum;
      let FM_SUBJECT = this.noticy_subject;
      let FILTER_OUTER_SPAM_ADD_HEADER_VALUE = this.header_value;

      let FILTER_OUTER_SPAM_ADD_HEADER_KEY = this.header_key;
      let FILTER_OUTER_ACTION = this.filter_outer_action;
      let str = this.$qs.stringify({
        __mode: "save_filter_param",
        sid: sid,
        check_awl: CHECK_AWL,
        save_reject_msg: SAVE_REJECT_MSG,
        filter_level: this.filter_level,
        weak_pwd_chk: this.weak_pwd_chk == true ? 1 : 0,
        smtp_auth_ip_limit: CHK_SMTP_AUTH_IP_LIMIT,
        close_local_digest: CLOSE_LOCAL_DIGEST,
        chk_sub_audit: this.chk_sub_audit == 1 ? true : false,
        sub_audit_time: SUB_AUDIT_INTERVAL,
        sub_audit_num: SUB_MAX_AUDIT_CN,
        max_nb_url_on_one_ip: MAX_NB_URL_ON_ONE_IP,
        chk_body_url_at_max_linknum: CHK_BODY_URL_AT_MAX_LINKNUM,
        noticy_subject: FM_SUBJECT,
        check_white_regex: CHECK_WHITE_REGEX,
        header_value: FILTER_OUTER_SPAM_ADD_HEADER_VALUE,
        header_key: FILTER_OUTER_SPAM_ADD_HEADER_KEY,
        filter_outer_action: FILTER_OUTER_ACTION,
        guess_pass_on: this.pass_on_yes == true ? 1 : 0,
        save_reject_outmail: this.save_reject_outmail == true ? 1 : 0,
        add_subject_spam_tag_on: this.add_subject_spam_tag_on == true ? 1 : 0,
        add_gl_subject_tag: this.add_gl_subject_tag,
        data_loadok: this.data_loadok,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList1();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 病毒加载
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_virus_param",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.q_action = res.data.ret.q_action;
            this.check_virus =
              res.data.ret.result.VIRUS_SCAN == 1 ? true : false;
            this.save_virus_msg =
              res.data.ret.result.SCANNER_SAVE == 1 ? true : false;

            this.qm_scan = res.data.ret.result.QM_SCAN == 1 ? true : false;

            this.scanner_timeout = res.data.ret.result.SCANNER_TIMEOUT;
            this.scanner_maxsize = res.data.ret.result.SCANNER_MAX_MSG_SIZE;
            this.qm_scan_port = res.data.ret.result.QM_SCAN_PORT;
            this.qm_scan_host = res.data.ret.result.QM_SCAN_HOST;
            this.scanner_action = res.data.ret.result.SCANNER_ACTION;
            this.scanner_size_unit = res.data.ret.result.SCANNER_SIZE_UNIT;
            this.data_loadok = res.data.ret.ok;
            this.anit_virus_socket = res.data.ret.result.ANTI_VIRUS_SOCKET;
            this.anit_virus_on =
              res.data.ret.result.ANTI_VIRUS_ON == 1 ? true : false;
            this.anit_virus_prog = res.data.ret.result.ANTI_VIRUS_PROG;
            this.anit_virus_on_show =
              res.data.ret.result.SYS_360_ANTI_VIRUS_CFG_ON;
            this.anit_virus_on_show1 = res.data.ret.result.SHOW_ANTI_VIRUS_PROG;
            this.anit_virus_on_show2 = res.data.ret.result.SHOW_ANTI_VIRUS_ON;
            this.anit_virus_ruisxing_show =
              res.data.ret.result.SYS_RUISXING_VIRUS_CFG_ON;
            this.ruixing_virus_show =
              res.data.ret.result.SYS_RUIXING_VIRUS_CFG_ON;
            this.clean_virus_on_show = res.data.ret.result.SYS_CLEAN_VIRUS_ON;
            this.redirect_virus_attach_on_show =
              res.data.ret.result.SYS_REDIRECT_VIRUS_ATTACH_ON;
            this.redirect_virus_attach_on =
              res.data.ret.result.REDIRECT_VIRUS_ATTACH_ON == 1 ? true : false;
            this.clean_virus_while_savespam_on =
              res.data.ret.result.CLEAN_VIRUS_WHILE_SAVESPAM_ON == 1
                ? true
                : false;
            this.clean_virus_on =
              res.data.ret.result.CLEAN_VIRUS_ON == 1 ? true : false;
          }
        });
    },
    // 病毒保存
    save2() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      // let q_action = this.q_action;

      let VIRUS_SCAN = this.check_virus == true ? 1 : 0;

      let SCANNER_SAVE = this.save_virus_msg == true ? 1 : 0;
      let QM_SCAN = this.qm_scan == true ? 1 : 0;

      let SCANNER_TIMEOUT = this.scanner_timeout;
      let SCANNER_MAX_MSG_SIZE = this.scanner_maxsize;
      let QM_SCAN_PORT = this.qm_scan_port;
      let QM_SCAN_HOST = this.qm_scan_host;
      let SCANNER_ACTION = this.scanner_action;
      let scanner_size_unit = this.scanner_size_unit;
      let str = this.$qs.stringify({
        __mode: "save_virus_param",
        sid: sid,
        check_virus: VIRUS_SCAN,
        save_virus_msg: SCANNER_SAVE,
        qm_scan: QM_SCAN,
        scanner_timeout: SCANNER_TIMEOUT,
        scanner_maxsize: SCANNER_MAX_MSG_SIZE,
        qm_scan_port: QM_SCAN_PORT,
        qm_scan_host: QM_SCAN_HOST,
        scanner_action: SCANNER_ACTION,
        scanner_size_unit: scanner_size_unit,
        data_loadok: this.data_loadok,
        anti_virus_socket: this.anit_virus_socket,
        anti_virus_prog: this.anit_virus_prog,
        anti_virus_on: this.anit_virus_on == true ? 1 : 0,
        clean_virus_on: this.clean_virus_on == true ? 1 : 0,
        clean_virus_while_savespam_on:
          this.clean_virus_while_savespam_on == true ? 1 : 0,
        redirect_virus_attach_on: this.redirect_virus_attach_on == true ? 1 : 0,
      });
      this.$axios
        .post("/api/adm/cgi/newspam.cgi", str)
        .then((res) => {
          // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList2();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        })
        .catch((err) => {
          console.log("接口错误");
          console.log(err);
          alert(err);
        });
    },
    // 日志清理加载
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_logclean_param",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.different_ategories_arr = res.data.ret.different_ategories;
            this.log_dft_pagesize_arr=res.data.ret.q_pagesize;
            this.maillog_file_save_days =
              res.data.ret.result.maillog_file_save_days;
            this.milterlog_file_save_days =
              res.data.ret.result.milterlog_file_save_days;
            this.fauth_file_save_days =
              res.data.ret.result.fauth_file_save_days;
            this.queue_save_days = res.data.ret.result.queue_save_days;
            this.conn_spam_save_days = res.data.ret.result.conn_spam_save_days;
            this.spam_save_days = res.data.ret.result.spam_save_days;
            this.archive_save_days = res.data.ret.result.archive_save_days;
            this.log_dft_pagesize = res.data.ret.result.log_dft_pagesize;
            this.area_save_days = res.data.ret.result.area_save_days;
            this.area_save_days_text = res.data.ret.area_save_days_text;
            this.area_save_days_show=res.data.ret.SYS_NEW_POLICY_GROUP_ON ;
            this.logcleam_person_show=res.data.ret.SYS_LOGCLEAN_PERSON_ON ;
            
            this.data_loadok = res.data.ret.ok;
          }
        });
    },
    // 日志清理保存
    save3() {
      // this.loading = true;
this.$save_hint_test();
this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let maillog_file_save_days = this.maillog_file_save_days;
      let milterlog_file_save_days = this.milterlog_file_save_days;
      let fauth_file_save_days = this.fauth_file_save_days;
      let queue_save_days = this.queue_save_days;
      let conn_spam_save_days = this.conn_spam_save_days;
      let spam_save_days = this.spam_save_days;
      let archive_save_days = this.archive_save_days;
      let log_dft_pagesize = this.log_dft_pagesize;
      let str = this.$qs.stringify({
        __mode: "save_logclean_param",
        sid: sid,
        maillog_file_save_days: maillog_file_save_days,
        milterlog_file_save_days: milterlog_file_save_days,
        fauth_file_save_days: fauth_file_save_days,
        queue_save_days: queue_save_days,
        conn_spam_save_days: conn_spam_save_days,
        spam_save_days: spam_save_days,
        archive_save_days: archive_save_days,
        log_dft_pagesize: log_dft_pagesize,
        area_save_days:this.area_save_days,
        data_loadok: this.data_loadok,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;

          this.getFileList3();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 警报加载
    getFileList4() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_alert_param",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.data_loadok = res.data.ret.ok;
            this.alert_sender = res.data.ret.result.alert_sender;
            this.alert_cur_queue_quota =
              res.data.ret.result.alert_cur_queue_quota;
            this.alert_disk_quota = res.data.ret.result.alert_disk_quota;
            this.alert_ip_auth_quota = res.data.ret.result.alert_ip_auth_quota;
            this.alert_ip_rej_quota = res.data.ret.result.alert_ip_rej_quota;
            this.alert_recipient = res.data.ret.result.alert_recipient;
            this.alert_time = res.data.ret.result.alert_time;

            this.alert_type_cur_queue =
              res.data.ret.result.alert_type_cur_queue == 1 ? true : false;

            this.alert_type_prosess =
              res.data.ret.result.alert_type_prosess == "1"
                ? (this.alert_type_prosess = true)
                : (this.alert_type_prosess = false);
            this.alert_type_sender =
              res.data.ret.result.alert_type_sender == "1"
                ? (this.alert_type_sender = true)
                : (this.alert_type_sender = false);
            this.alert_type_disk =
              res.data.ret.result.alert_type_disk == "1"
                ? (this.alert_type_disk = true)
                : (this.alert_type_disk = false);
            this.alert_type_auth_ip =
              res.data.ret.result.alert_type_auth_ip == "1"
                ? (this.alert_type_auth_ip = true)
                : (this.alert_type_auth_ip = false);
            this.alert_type_update =
              res.data.ret.result.alert_type_update == "0"
                ? (this.alert_type_update = false)
                : (this.alert_type_update = true);
            this.alert_type_license =
              res.data.ret.result.alert_type_license == "0"
                ? (this.alert_type_license = false)
                : (this.alert_type_license = true);
            this.alert_type_rej_ip =
              res.data.ret.result.alert_type_rej_ip == 1 ? true : false;
            this.alert_cert_expire =
              res.data.ret.result.alert_cert_expire == 1 ? true : false;
            this.alert_cert_expire_show =
              res.data.ret.result.alert_cert_expire_hint;
            this.alert_sender_show = res.data.ret.result.alert_sender_hint1;
            this.alert_recipient_show =
              res.data.ret.result.alert_recipient_hint1;
            this.alert_type_disk_show =
              res.data.ret.result.alert_type_disk_hint;
            this.alert_type_auth_ip_show =
              res.data.ret.result.alert_type_auth_ip_hint;
            this.alert_type_rej_ip_show =
              res.data.ret.result.alert_type_rej_ip_hint;
            this.alert_type_sender_show =
              res.data.ret.result.alert_type_sender_hint;
            this.alert_type_update_show =
              res.data.ret.result.alert_type_update_hint;
            this.alert_type_cur_queue_show =
              res.data.ret.result.alert_type_cur_queue_hint;
            this.alert_type_license_show =
              res.data.ret.result.alert_type_license_hint;
            this.alert_cert_expire_show =
              res.data.ret.result.alert_cert_expire_hint;
            this.alert_type_prosess_show =
              res.data.ret.result.alert_type_prosess_hint;
          }
        });
    },
    // 警报保存
    save4() {
      // this.loading = true;
this.$save_hint_test();
this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_alert_param",
        sid: sid,
        alert_sender: this.alert_sender,
        alert_recipient: this.alert_recipient,
        alert_disk_quota: this.alert_disk_quota,
        alert_ip_auth_quota: this.alert_ip_auth_quota,

        alert_ip_rej_quota: this.alert_ip_rej_quota,
        alert_cur_queue_quota: this.alert_cur_queue_quota,
        alert_type_disk: this.alert_type_disk == true ? 1 : 0,
        alert_type_prosess: this.alert_type_prosess == true ? 1 : 0,
        alert_type_auth_ip: this.alert_type_auth_ip == true ? 1 : 0,
        alert_type_rej_ip: this.alert_type_rej_ip == true ? 1 : 0,
        alert_type_sender: this.alert_type_sender == true ? 1 : 0,
        alert_type_update: this.alert_type_update == true ? 1 : 0,
        alert_type_cur_queue: this.alert_type_cur_queue == true ? 1 : 0,
        alert_type_license: this.alert_type_license == true ? 1 : 0,
        alert_cert_expire: this.alert_cert_expire == true ? 1 : 0,

        data_loadok: this.data_loadok,
        alert_time: 8,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList4();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    add_black_five() {
      this.tanchu = true;
      this.real_code = "";
      this.real_addr = "";
    },
    // 实时黑名单加载
    getFileList5() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_real_bl",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList5 = res.data.ret.datalist;
          }
        });
    },
    // 实时黑名单保存
    save5() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let REAL_ADDR = this.real_addr;
      let REAL_CODE = this.real_code;
      let str = this.$qs.stringify({
        __mode: "save_real_bl",
        sid: sid,
        real_code: REAL_CODE,
        real_addr: REAL_ADDR,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        this.loading = false;
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;

          this.loading = false;
          this.getFileList5();
        }
      });
    },
    // 实时黑名单修改
    save52() {
      this.$disable_hint_test();
      this.$save_hint_test();
       this.loading_five = true;
      // this.bxian1 = false
      // this.bxian = true
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let REAL_ADDR = this.real_addr;
      let REAL_CODE = this.real_code;
      let str = this.$qs.stringify({
        __mode: "save_real_bl",
        sid: sid,
        real_code: REAL_CODE,
        real_addr: REAL_ADDR,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        this.$close_hint_test();
        this.$close_disable_hint_test();
        console.log(res);
      
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          this.loading_five=false

          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
           this.loading_five=false
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
      this.tanchu1 = false;

          this.loading_five = false;
          this.getFileList5();
        }
      });

      // this.real_code = "";
      // this.real_addr = "";
    },
    // 实时黑名单编辑
    save51(index, scope) {
      this.tanchu1 = true;
      // console.log(scope)
      this.bxian = false;
      this.bxian1 = true;
      this.real_code = scope.REAL_CODE;
      this.real_addr = scope.REAL_ADDR;
    },
    // 实时黑名单删除
    handleClick(index, scope) {
      // console.log(index, scope)
       this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let REAL_ADDR = scope.REAL_ADDR;
          let REAL_CODE = scope.REAL_CODE;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "del_real_bl",
                sid: sid,
                real_code: REAL_CODE,
                real_addr: REAL_ADDR,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                // alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList5();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 远程配置加载
    getFileList6() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_remote_syslog",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.data_loadok = res.data.ret.ok;
            this.filterlog_syslog =
              res.data.ret.result.ENABLE_REMOTE_LOG == 0
                ? (this.filterlog_syslog = false)
                : (this.filterlog_syslog = true);
            this.syslog_remote_host = res.data.ret.result.syslog_remote_host;
            this.add_syslog_name = res.data.ret.result.REMOTE_LOG_OPT_HDR;
          }
        });
    },
    // 远程配置保存
    save6() {
      // this.loading = true;
this.$save_hint_test();
this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let ENABLE_REMOTE_LOG = this.filterlog_syslog == false ? 0 : 1;
      let syslog_remote_host = this.syslog_remote_host;
      let add_syslog_name = this.add_syslog_name;
      let str = this.$qs.stringify({
        __mode: "save_remote_syslog",
        sid: sid,
        syslog_remote_host: syslog_remote_host,
        add_syslog_name: add_syslog_name,
        filterlog_syslog: ENABLE_REMOTE_LOG,
        data_loadok: this.data_loadok,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList6();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 离线测试加载
    getFileList7() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_offline_test",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;

            this.offline_test_on =
              res.data.ret.result.offline_test_on == "1"
                ? (this.offline_test_on = true)
                : (this.offline_test_on = false);
            this.offline_test_sender = res.data.ret.result.offline_test_sender;
            this.data_loadok = res.data.ret.ok;
          }
        });
    },
    // 离线测试保存
    save7() {
      // this.loading = true;
this.$save_hint_test();
this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let offline_test_on =
        this.offline_test_on == true
          ? (offline_test_on = "1")
          : (offline_test_on = "0");
      let offline_test_sender = this.offline_test_sender;
      let str = this.$qs.stringify({
        __mode: "save_offline_test",
        sid: sid,
        offline_test_sender: offline_test_sender,

        offline_test_on: offline_test_on,
        data_loadok: this.data_loadok,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList7();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // smtp 取消
    cancel() {},
  },
};
</script>

<style lang="less" scoped>
// 反病毒
.bingdu {
  .el-input {
    /deep/ .el-input {
      width: 200px !important;
    }
  }

  /deep/ .el-input--suffix {
    width: 100px;
  }
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .el-checkbox-group {
  margin-right: 10px !important;
}
.smtp_basic tbody td:nth-child(1) {
  width: 230px;
}
.pop-up1 {
  position: fixed;
  // padding: 20px 0;
  width: 40%;
  height: auto;
  top: 10%;
  left: 25%;
  z-index: 101;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  background: white;

  border-radius: 4px;
  padding-bottom: 14px;

  //   margin-left: -12.5%;
  //   margin-top: -14%;
  .find-text {
    width: 100px;
  }
}
.pop-up .pop_up_text {
  width: 100%;

}
.pop_up_text_edit,
.pop_up_text_add {
  background: #eee;
}
</style>
